import React from 'react'
import { observer } from 'mobx-react'
import './styles.sass'

const RealtimeChallengeView = ({ challenge }) => (
  <div className="realtime-challenge">
    {challenge.image &&
      <div className="captcha-container">
        <img src={challenge.image.source} alt="Captcha" />
      </div>
    }

    <input
      type="text"
      className="input"
      placeholder="Write your answer here"
      value={challenge.answer}
      onChange={e => challenge.setAnswer(e.target.value)}
    />
  </div>
)

export default observer(RealtimeChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/RealtimeChallenge/View.jsx